import { LoginRoute } from './routes.js';
/**
 * Helper function to get the login route with a redirect parameter.
 * @param params - The parameters for the login route.
 * @returns The login route with the redirect parameter.
 */
export function getLoginRoute(params) {
    let redirect = params?.redirect;
    if (redirect && typeof redirect !== 'string') {
        redirect = redirect.fullPath;
    }
    return LoginRoute({
        locale: params?.locale,
        $query: { redirect },
    });
}
//# sourceMappingURL=routeUtils.js.map